module.exports = __webpack_public_path__ + "img/yz_router_mode.2519372e.svg";